export function authHeader() {
    // return authorization header with jwt token
    let key = 'token';
    let token = JSON.parse(window.sessionStorage.getItem(key) ?? window.localStorage.getItem(key));
    if (token) {
        return 'Bearer ' + token;
    } else {
        return '';
    }
}